import * as React from 'react';
import { CoreCheckbox } from '../internal/WixUiCoreComponents/components/CoreCheckbox';
import { st, classes } from './IconToggle.st.css';
import { deprecationLog } from '../../common/deprecationLog';
import { IconToggleLabelPlacement, IconToggleProps } from './types';

interface DefaultProps {
  label: React.ReactNode;
  labelPlacement: IconToggleLabelPlacement;
  checked: boolean;
  disabled: boolean;
  animation: boolean;
}

/**
 * A toggle button represented by an icon and label
 */
export class IconToggle extends React.Component<IconToggleProps> {
  static displayName = 'IconToggle';
  static defaultProps: DefaultProps = {
    label: '',
    labelPlacement: IconToggleLabelPlacement.END,
    checked: false,
    disabled: false,
    animation: false,
  };

  componentDidMount(): void {
    if (this.props.icon && !this.props.checkedIcon) {
      deprecationLog(
        'IconToggle',
        'The current API of this component is deprecated and will be removed in a future version, please use both "checkedIcon" and "icon" props.',
      );
    }
  }

  _getContent = () => {
    const { checkedIcon, checked, icon, label } = this.props;

    return (
      <div className={classes.content}>
        <div data-icon className={classes.icon}>
          {checkedIcon && checked ? checkedIcon : icon}
        </div>
        {label ? <div className={classes.spacer} /> : null}
        {label ? (
          <div data-label className={classes.label}>
            {label}
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    const {
      label,
      labelPlacement,
      onChange,
      checked,
      disabled,
      animation,
      className,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
    } = this.props;

    const content = this._getContent();

    return (
      <span
        data-label-placement={labelPlacement}
        className={st(
          classes.root,
          { checked, disabled, labelPlacement, animation },
          className,
        )}
        data-hook={this.props['data-hook']}
      >
        <CoreCheckbox
          uncheckedIcon={content}
          checkedIcon={content}
          indeterminateIcon={content}
          error={false}
          indeterminate={false}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          aria-label={
            ariaLabel || (typeof label === 'string' ? label : undefined)
          }
          aria-labelledby={ariaLabelledBy}
        />
      </span>
    );
  }
}
